import React, { lazy, Suspense } from "react";

const LazyListBackUp = lazy(() => import("./ListBackUp"));

export const ListBackUp = () => (
  <Suspense fallback="loading...">
    <LazyListBackUp />
  </Suspense>
);
